import RoutingV2ApiService from "../services/routingV2Api";
import { getLatLng } from "../services/hereMapsService";
import { fetchRoutingUserProfileId, fetchUser } from "./fetchUser";
import { formatMilisecondsInDaysHoursMinutes } from "../utils/dateUtils";
import RoutingApiService from "../services/routingApi";
import { getAmityToken } from "../services/amityService";
import { fetchDealershipsDnGroup } from "./fetchDealerships";

export const createRoute = async (
    origin: string,
    destination: string,
    routeName: string,
    responsibleId: string
): Promise<{ wasCreated: boolean, routeId: string, error?: string }> => {
    const originLatLng = await getLatLng(origin);
    const destinationLatLng = await getLatLng(destination);

    const routingV2ApiService = new RoutingV2ApiService();

    try {
        const response = await routingV2ApiService.post<{ status: string, data: { result: string } }>("/routes/rio/send", {
            "routeName": routeName,
            "originRoute": {
                "address": {
                    "label": origin
                },
                "addressStop": {
                    "label": origin
                },
                "lat": originLatLng?.lat,
                "lng": originLatLng?.lng
            },
            "destinyRoute": {
                "address": {
                    "label": destination
                },
                "addressStop": {
                    "label": destination
                },
                "lat": destinationLatLng?.lat,
                "lng": destinationLatLng?.lng
            },
            "rangeToleranceLimit": 0,
            "stops": [],
            "roadParameters": {
                "trafficConditions": "false",
                "avoidToll": false,
                "avoidRoad": false,
                "ignoreTrafficRestrictions": false
            },
            "vehicleVocationalInfo": {
                "height": 0,
                "width": 0,
                "comTotal": 0,
                "grossWeight": 0,
                "maxAxleLoad": 0,
                "numberOfAxles": 0,
                "trailerAxles": 0,
                "type": "TRUCK",
                "shippedHazardousGoods": ""
            },
            "costs": {
                "tollValue": "0",
                "operativeCosts": "0",
                "fuelAverageCosts": "0",
                "averageConsume": "0",
                "totalCosts": "0.00"
            },
            "responsibleId": responsibleId,
            "status": true,
            "linkedVehicles": [],
            "responseHere": {
                "routes": []
            },
            "duration": "0h0min"
        });
        return response.status < 300 ? {
            wasCreated: true,
            routeId: response.data.data.result
        } : {
            wasCreated: false,
            routeId: "",
            error: "Erro ao criar rota"
        };
    } catch (error) {
        console.error(error);
        return {
            wasCreated: false,
            routeId: "",
            error: "Erro ao criar rota"
        };
    }
}

const resolveRouteLatLng = async (
    address: string,
    geoLocation?: { lat?: number; lng?: number }
): Promise<{ lat: number; lng: number } | null> => {
    if (geoLocation?.lat && geoLocation?.lng) {
        return { lat: geoLocation.lat, lng: geoLocation.lng };
    }
    return getLatLng(address);
};

export const createv2Route = async (
    origin: { address: string; lat?: number; lng?: number },
    destination: { address: string; lat?: number; lng?: number },
    routeName: string,
    vehicleType: "CAR" | "TRUCK",
    dn: string,
    chassis?: string,
    dispatchId?: string,
    vehicleName?: string,
    stayTime?: string
): Promise<{ wasCreated: boolean, routeId: string, error?: string, errorId?: string }> => {
    const originLatLng = await resolveRouteLatLng(origin.address, origin);
    const destinationLatLng = await resolveRouteLatLng(destination.address, destination);
    const dnRes = await fetchDealershipsDnGroup(dn);
    let profileId = await fetchRoutingUserProfileId();
    const routingV2ApiService = new RoutingV2ApiService();

    try {
            const response = await routingV2ApiService.post<{ status: string, data: { result: string } }>("/routes/rio/send/trip/emergency", {
                "route": {
                    "routeName": routeName,
                    "rangeToleranceLimit": 50.0,
                    "duration": "01:00",
                    "originRoute": {
                        "lat": originLatLng?.lat,
                        "lng": originLatLng?.lng,
                        "address": {
                            "label": origin.address
                        }
                    },
                    "destinyRoute": {
                        "lat": originLatLng?.lat,
                        "lng": originLatLng?.lng,
                        "address": {
                            "label": origin.address
                        }
                    },
                    "stops": [
                        {
                            "name": "Local da Pane",
                            "type": "STOPOVER",
                            "category": "MECHANICAL_EMERGENCY",
                            "rangeLimitMeters": "200",
                            "stayTime": stayTime || "01:00",
                            "order": 1,
                            "position": {
                                "lat": destinationLatLng?.lat,
                                "lng": destinationLatLng?.lng,
                                "address": {
                                    "label": destination.address
                                }
                            }
                        }
                    ],
                    "costs": {
                        "tollValue": "0",
                        "operativeCosts": "0",
                        "totalCosts": "0",
                        "fuelAverageCosts": "0",
                        "averageConsume": "0"
                    },
                     "vehicleVocationalInfo": {
                        "type": vehicleType
                    },
                    "roadParameters": {
                        "trafficConditions": "false",
                        "avoidToll": "false",
                        "avoidRoad": "false",
                        "ignoreTrafficRestrictions": "false"
                    },
                },
                "emergencyInfo": {
                    "checklistType": "MECHANICAL_EMERGENCY",
                    "dnGroupId": dnRes?.groupId,
                    "chassis": chassis,
                    "vehicleAttended":  vehicleName || chassis,
                    'idOcurrence': dispatchId

                }
            }, {
                headers: {
                    'unique-profile-id': profileId
                }
            });

        return response.status < 300 ? {
            wasCreated: true,
            routeId: response.data.data.result
        } : {
            wasCreated: false,
            routeId: "",
            error: "Erro ao criar rota",
            errorId: "intl-msg:kanban.form.chooseDealershipDialog.createRouteError"
        };
    } catch (error) {
        console.error(error);
        return {
            wasCreated: false,
            routeId: "",
            error: "Erro ao criar rota",
            errorId: "intl-msg:kanban.form.chooseDealershipDialog.createRouteError"
        };
    }
}

export interface Route {
    id: string;
    name: string;
    origin: string;
    originGeoLocation: {
        lat: number;
        lng: number;
    };
    destination: string;
    destinationGeoLocation: {
        lat: number;
        lng: number;
    };
}

export const getRoute = async (routeId: string): Promise<{ wasCreated: boolean, route: Route | null, error?: string }> => {
    const routingV2ApiService = new RoutingV2ApiService();
    const response = await routingV2ApiService.get<any>(`/routes/route/${routeId}`);
    if (response.status < 300) {
        const data = response.data.data.result;

        return {
            wasCreated: true,
            route: {
                id: data.id,
                name: data.routeName,
                origin: data.originRoute.address.label,
                originGeoLocation: {
                    lat: data.originRoute.lat,
                    lng: data.originRoute.long
                },
                destination: data.destinyRoute.address.label,
                destinationGeoLocation: {
                    lat: data.destinyRoute.lat,
                    lng: data.destinyRoute.long
                }
            }
        }
    } else {
        return {
            wasCreated: false,
            route: null,
            error: "Erro ao buscar rota"
        };
    }
}

const getHereRoute = async (route: Route, departureTime: string): Promise<{ wasCreated: boolean, route: any | null, error?: string }> => {
    const routingV2ApiService = new RoutingV2ApiService();
    const response = await routingV2ApiService.post<any>(`/routes/mount`, {
        "origin": {
            "lat": route.originGeoLocation.lat,
            "lng": route.originGeoLocation.lng
        },
        "destination": {
            "lat": route.destinationGeoLocation.lat,
            "lng": route.destinationGeoLocation.lng
        },
        "via": [],
        "vehicle": {
            "height": 0,
            "width": 0,
            "length": 0,
            "numberOfAxles": 0,
            "trailerAxles": 0,
            "grossWeight": 0,
            "maxWeightAxle": 0,
            "vehicleType": "TRUCK",
            "shippedHazardousGoods": "NONE"
        },
        "departureTime": departureTime,
        "avoidToll": false,
        "transport": { "mode": "TRUCK" }
    });
    return response.status < 300 ? {
        wasCreated: true,
        route: response.data
    } : {
        wasCreated: false,
        route: null,
        error: "Erro ao buscar rota"
    }
}

const createTripRoute = async (
    routeId: string,
    accountId: string,
    profileId: string,
): Promise<{ wasCreated: boolean, routeTripId: string, error?: string }> => {
    const oldRoute = await getRoute(routeId);
    if (!oldRoute.wasCreated || !oldRoute.route) {
        return {
            wasCreated: false,
            routeTripId: "",
            error: "Rota não encontrada"
        };
    }

    const { origin, name, originGeoLocation, destination, destinationGeoLocation } = oldRoute.route;

    const hereRoute = await getHereRoute(oldRoute.route, new Date().toISOString());
    if (!hereRoute.wasCreated || !hereRoute.route) {
        return {
            wasCreated: false,
            routeTripId: "",
            error: "Erro ao buscar rota"
        };
    }

    const routingV2ApiService = new RoutingV2ApiService();

    try {
        const response = await routingV2ApiService.post<{ status: string, data: { result: string } }>(`/routes/rio/send/trip`, {
            "id": routeId,
            "accountId": accountId,
            "routeName": `${name} - PERSONALIZADO`,
            "originRoute": {
                "address": {
                    "label": origin
                },
                "addressStop": {
                    "label": origin
                },
                "lat": originGeoLocation.lat,
                "lng": originGeoLocation.lng,
                "checkpointId": {
                    "lat": originGeoLocation.lat,
                    "lng": originGeoLocation.lng,
                    "label": origin
                }
            },
            "destinyRoute": {
                "address": {
                    "label": destination
                },
                "addressStop": {
                    "label": destination
                },
                "lat": destinationGeoLocation.lat,
                "lng": destinationGeoLocation.lng
            },
            "rangeToleranceLimit": 0,
            "stops": [],
            "roadParameters": {
                "trafficConditions": "false",
                "avoidToll": false,
                "avoidRoad": false,
                "ignoreTrafficRestrictions": false
            },
            "vehicleVocationalInfo": {
                "height": 0,
                "width": 0,
                "comTotal": 0,
                "grossWeight": 0,
                "maxAxleLoad": 0,
                "numberOfAxles": 0,
                "trailerAxles": 0,
                "type": "TRUCK",
                "shippedHazardousGoods": ""
            },
            "costs": {
                "tollValue": "0",
                "operativeCosts": "0",
                "fuelAverageCosts": "0",
                "averageConsume": "0",
                "totalCosts": "0.00"
            },
            "responsibleId": profileId,
            "status": true,
            "linkedVehicles": [],
            "responseHere": hereRoute.route,
            "duration": formatMilisecondsInDaysHoursMinutes((hereRoute.route.routes[0]?.sections[0]?.summary?.duration ?? 0) * 1000).split(" ").join("")
        }, {
            headers: {
                'unique-profile-id': profileId,
            }
        });

        return response.status < 300 ? {
            wasCreated: true,
            routeTripId: response.data.data.result
        } : {
            wasCreated: false,
            routeTripId: "",
            error: "Erro ao criar viagem"
        };
    } catch (error) {
        console.error(error);
        return {
            wasCreated: false,
            routeTripId: "",
            error: "Erro ao criar viagem"
        };
    }
}

export const createTrip = async (
    routeId: string,
    userId: string,
    driverId: string,
    driverName: string,
    assetId: string,
    assetName: string,
    startDateTime: string,
    profileId: string,
): Promise<{ wasCreated: boolean, tripId: string, error?: string, errorId?: string }> => {
    const userProfileId = await fetchRoutingUserProfileId();
    if (!userProfileId) {
        return {
            wasCreated: false,
            tripId: "",
            error: "Erro ao buscar perfil",
            errorId: "intl-msg:shared.apiError.routing.fetchProfile"
        };
    }

    const userData =
        userProfileId === 'ec6e5df5-b523-4428-bacd-48d04b90a234' || !userId ?
            { name: 'John Doe', firstName: 'John', lastName: 'Doe', email: 'john.doe@test.com' } : // Mock user
            await fetchUser(userId);

    if (!userData || !userData.accountId) {
        return {
            wasCreated: false,
            tripId: "",
            error: "Erro ao buscar usuário",
            errorId: "intl-msg:kanban.form.createTripDialog.fetchUserError"
        };
    }

    const tripRoute = await createTripRoute(routeId, userData.accountId, profileId);
    if (!tripRoute.wasCreated || !tripRoute.routeTripId) {
        return {
            wasCreated: false,
            tripId: "",
            error: "Erro ao criar viagem",
            errorId: "intl-msg:kanban.form.createTripDialog.createTripError"
        };
    }

    const routingV2ApiService = new RoutingV2ApiService();

    try {
        const response = await routingV2ApiService.post<{ status: string, data: { result: string } }>(`/routes/rio/send/trip/${routeId}`, {
            "linkedVehicles": [
                {
                    "driverId": driverId,
                    "assetId": assetId,
                    "routeId": tripRoute.routeTripId,
                    "profileId": profileId,
                    "assetName": assetName,
                    "driverName": driverName,
                    "startDateTime": startDateTime
                }
            ]
        }, {
            headers: {
                'unique-profile-id': profileId,
            }
        });
        return response.status < 300 ? {
            wasCreated: true,
            tripId: response.data.data.result
        } : {
            wasCreated: false,
            tripId: "",
            error: "Erro ao criar viagem",
            errorId: "intl-msg:kanban.form.createTripDialog.createTripError"
        };
    } catch (error) {
        console.error(error);
        return {
            wasCreated: false,
            tripId: "",
            error: "Erro ao criar viagem",
            errorId: "intl-msg:kanban.form.createTripDialog.createTripError"
        };
    }
}

export const getFollowersProfiles = async (): Promise<{ wasCreated: boolean, profiles: { id: string, name: string, type: string }[] | null, error?: string }> => {
    const profileId = await fetchRoutingUserProfileId();
    const routingApiService = new RoutingApiService();
    const amityToken = getAmityToken();
    
    const headers: Record<string, string> = {};
    if (amityToken) {
        headers['token_amity'] = amityToken;
    }
    
    const response = await routingApiService.get<any>(`/social/followers/${profileId}`, { headers });
    
    return response.status < 300 ? {
        wasCreated: true,
        profiles: (response.data.data?.result?.users ?? [])
            .map((user: any) => ({
                id: user.metadata?.uniqueProfileId,
                name: user.metadata?.displayName || `${user.metadata?.givenName} ${user.metadata?.familyName}`,
                type: user.metadata?.profileType
            }))
    } : {
        wasCreated: false,
        profiles: null,
        error: "Erro ao buscar perfis"
    }
}